<div class="section">
    <div class="px-3">
        <div class="theme-container">
            <h1 class="section-title">Our Table Service</h1>
            <p class="section-desc text-muted">This is what we do and we do it perfectly.</p>

            <div fxLayout="row wrap" class="services-wrapper">
                <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Main Choice Menu</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <img style="height:360px; width: 180px" [src]="'assets/images/tableService1.png'" />
                        </div>

                    </mat-card>
                </div>
                <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Choose your products</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <img style="height:360px; width: 180px" [src]="'assets/images/tableService2.png'" />
                        </div>

                    </mat-card>
                </div>
                <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Booking confirmation</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <img style="height:360px; width: 180px" [src]="'assets/images/tableService3.png'" />
                        </div>

                    </mat-card>
                </div>
                <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Paypal or credit cards</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <img style="height:360px; width: 180px" [src]="'assets/images/tableService4.png'" />
                        </div>

                    </mat-card>
                </div>
            </div>


            <a mat-raised-button routerLink="/table-service" color="primary" class="uppercase">Read more about our table service</a>
        </div>
    </div>
</div>